import axiosClient from "api/axios_client.js";

const BASE = "/knowledge-management/knowledge-configuration/knowledge-base";

const apiKnowledgeBase = {
  create: (payload) => axiosClient.post(`${BASE}/create`, payload),
  update: (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getById: (id) => axiosClient.get(`${BASE}/get-by-id/${id}`),
  getAll: (payload) => axiosClient.post(`${BASE}/get-all`, payload),
  delete: (ids) => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),

  // Dropdown data for the knowledge-base form and filters
  getTradeOfWorksForDropdown: () => axiosClient.get(`/directories/business-master/trade-of-work/get-all`),
  getBusinessTypesForDropdown: () => axiosClient.get(`/directories/business-master/business-type/get-all`),
  getUserRolesForDropdown: () => axiosClient.get(`/user-role-module/user-role/get-all`),
};

export default apiKnowledgeBase;
